import { render } from "./Fast_Moving_Items.vue?vue&type=template&id=5b92b133"
import script from "./Fast_Moving_Items.vue?vue&type=script&lang=js"
export * from "./Fast_Moving_Items.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__